module.exports = __webpack_public_path__ + "assets/img/af611cd51d76a58142af105b2faa32fe.svg";